import $ from "jquery";
import Swiper, {
  Autoplay,
  Controller,
  EffectFade,
  Lazy,
  Navigation,
  Pagination,
  Parallax,
  Thumbs,
} from "swiper";

$(function () {
  Swiper.use([
    Autoplay,
    Controller,
    EffectFade,
    Lazy,
    Navigation,
    Pagination,
    Parallax,
    Thumbs,
  ]);

  window.ResizeObserver = undefined;

  const swiperBanner = new Swiper(".banner__slider", {
    loop: true,
    lazy: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    parallax: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".banner__nav--next",
      prevEl: ".banner__nav--prev",
    },
    pagination: {
      el: ".banner__pagination",
      bulletClass: "banner__bullet",
      bulletActiveClass: "banner__bullet--active",
    },
  });

  const swiperTestimonials = new Swiper(".testimonials__slider", {
    loop: true,
    lazy: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
    },
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      1024: {
        slidesPerView: "auto",
      },
    },
    navigation: {
      nextEl: ".testimonials__nav--next",
      prevEl: ".testimonials__nav--prev",
    },
    pagination: {
      el: ".testimonials__pagination",
      bulletClass: "testimonials__bullet",
      bulletActiveClass: "testimonials__bullet--active",
    },
  });

  const swiperBenefitsContent = new Swiper(".benefits__slider-content", {
    direction: "vertical",
    loop: false,
    spaceBetween: 24,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });

  const swiperBenefitsBkground = new Swiper(".benefits__slider-bkground", {
    loop: true,
    lazy: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".benefits__nav--next",
      prevEl: ".benefits__nav--prev",
    },
    pagination: {
      el: ".benefits__pagination",
      bulletClass: "benefits__bullet",
      bulletActiveClass: "benefits__bullet--active",
      modifierClass: "benefits__pagination--",
    },
    thumbs: {
      swiper: swiperBenefitsContent,
    },
  });
});
